/*@ngInject*/
export default ['$translate', '$filter', ($translate, $filter) => {
    return function (array, i18nKeyPrefix, objKey) {
        let result = [];
        let translated = [];
        array.forEach((value) => {
            let i18nKeySuffix = objKey ? value[objKey] : value;
            translated.push({
                key: value,
                label: $translate.instant(i18nKeyPrefix + i18nKeySuffix)
            });
        });
        $filter('orderBy')(translated, 'label').forEach((sortedObject) => {
            result.push(sortedObject.key);
        });
        return result;
    };
}]
